module.exports = __webpack_public_path__ + "static/media/image-web-5.06a2426f.png";